import cx from 'classnames';
import { FC, useEffect } from 'react';

import { Image } from '@/components/molecules/Image/render';
import { ListShowsEvents } from '@/components/molecules/ListShowsEvents/render';
import { Section } from '@/helpers/Section';
import { injectFontFaces } from '@/utils/inject-font-faces';
import Link from 'next/link';

import block from './block.json';
import { getStyles } from './styles.css';

export const SectionFestival: FC<SectionFestivalProps> & BlockConfigs = ({
	anchor,
	title,
	titleColor,
	titleFont,
	titleLogo,
	link,
	shows = [],
}) => {
	useEffect(() => {
		if (!titleLogo && titleFont?.file) {
			const type = titleFont.file.mimeType.split('/').pop();
			injectFontFaces([
				{
					group: 'festival-section-title-' + title.replace(' ', '-'),
					value: `\n@font-face {\n\tfont-family: "${titleFont.name}";\n\tfont-weight: 500;\n\tfont-style: medium;\n\tfont-display: swap;\n\tsrc: url('${titleFont.file.url}') format('${type}')`,
				},
			]);
		}
	}, []);

	const rootClass = cx(
		'supt-section supt-section--section-festival',
		getStyles(titleColor, titleFont)
	);

	const headlineContent = (
		<>
			{titleLogo && (
				<Image
					src={titleLogo.src}
					alt={titleLogo.alt}
					width={titleLogo.width}
					height={titleLogo.height}
					className="supt-section__title-logo"
				/>
			)}
			<Section.Title text={title} titleTag="h2" />
		</>
	);

	return (
		<section id={anchor} className={rootClass}>
			<div className="supt-section__inner">
				<div className="supt-section__headline">
					{link ? (
						<Link href={link.url} target={link.target}>
							<a>{headlineContent}</a>
						</Link>
					) : (
						headlineContent
					)}
				</div>
				<div className="supt-section__content">
					<ListShowsEvents events={shows} />
				</div>
			</div>
		</section>
	);
};

SectionFestival.slug = block.slug;
SectionFestival.title = block.title;
